import { Configuration } from "Configuration";
import { BaseService } from "./BaseService";
import { DownloadFile, FileDownloadClient } from "./Client";

/**
 * Service for downloading files.
 * @hidden
 */
export class FileDownloadService extends BaseService {
    /**
     * Get file:
     */
    public get(fileId: number, objectId: number, tableName: string): Promise<DownloadFile> {
        let client = new FileDownloadClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return this.handleResult(
            new Promise<DownloadFile>((resolve, reject) => {
                client.get(
                    fileId,
                    objectId,
                    tableName,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
                // cancellationTokenSource.token.onCancelled((reason) => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }
}
